import { GoogleMap, Circle } from "@react-google-maps/api";
import { useEffect, useRef, useState } from "react";

import HNSColors from "../../../../../ui library/HNSColors";

import OriginMarker from "./OriginMarker";

export default function MapView({ center, selectedCenter, radius, data, children, markerData }) {
  const mapRef = useRef(null);
  const [zoom, setZoom] = useState(15);

  const handleMapLoad = (map) => {
    mapRef.current = map;
    map.setZoom(15);
  };

  const isValidLatLng = (p) =>
  p &&
  Number.isFinite(p.lat) &&
  Number.isFinite(p.lng);

const toLatLng = (lat, lng) => {
  const nLat = Number(lat);
  const nLng = Number(lng);
  return Number.isFinite(nLat) && Number.isFinite(nLng)
    ? { lat: nLat, lng: nLng }
    : null;
};


useEffect(() => {
  const map = mapRef.current;
  if (!map) {
    return;
  }

  const safeCenter = isValidLatLng(center) ? center : null;
  const safeSelected = isValidLatLng(selectedCenter) ? selectedCenter : null;

  if (safeCenter && safeSelected) {
    const midpoint = {
      lat: (safeCenter.lat + safeSelected.lat) / 2,
      lng: (safeCenter.lng + safeSelected.lng) / 2,
    };

    map.setCenter(midpoint);

    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend(safeCenter);
    bounds.extend(safeSelected);
    map.fitBounds(bounds);

  } else if (safeCenter) {
    map.setCenter(safeCenter);

    if (markerData?.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(safeCenter);

      for (let i = 0; i < markerData.length; i++) {
        const coords = toLatLng(
          markerData[i]?.address?.latitude,
          markerData[i]?.address?.longitude
        );

        if (coords) {
          bounds.extend(coords);
        }
      }

      map.fitBounds(bounds);
    } else {
      map.setZoom(15);
    }
  }
}, [center, selectedCenter, markerData]);


  const handleZoomChanged = () => {
    if (mapRef.current) {
      const newZoom = mapRef.current.getZoom();
      setZoom(newZoom);
      if (newZoom > 20) {
        setZoom(18);
      }
    }
  };

  if (!isValidLatLng(center)) {
    return null;
  }

  return (
    <GoogleMap
      onLoad={handleMapLoad}
      mapContainerStyle={{ width: "100%", height: "100%", borderRadius: 8 }}
      center={center}
      zoom={zoom}
      gestureHandling="greedy"
      disableDefaultUI={false}
      options={{
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        cameraControl: false,
      }}
      onZoomChanged={handleZoomChanged}
    >
      <OriginMarker position={center}/>

      {data?.length > 0 && isValidLatLng(center) && (
        <Circle
          center={center}
          radius={radius}
          options={{
            fillColor: HNSColors.tertiary[500],
            fillOpacity: 0.2,
            strokeColor: HNSColors.tertiary[500],
            strokeOpacity: 0.5,
            strokeWeight: 2,
          }}
        />
      )}
      {children}
    </GoogleMap>
  );
}
